var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.row.bank)?_c('img',{attrs:{"src":_vm.BankLogo(_vm.row.bank),"width":"32","height":"28"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }